<div >
    <a (click)="selectNode()">{{this.node.name}}</a>
</div>
<div *ngIf="displayAnswer">
    <span>{{node.answer}}</span>
</div>